import React, { useEffect, useState } from 'react';
import './Reviews.style.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import StarIcon from '@mui/icons-material/Star';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';

const BASE = process.env.REACT_APP_API_BASE_URL;

// Le texte des avis reste en dur (pas de vrais avis en base), mais le nom/la
// photo/la ville sont remplacés par un vrai utilisateur inscrit quand disponible.
const REVIEWS = [
  {
    text: "J'ai trouvé ma voiture en moins de 48h. Les annonces sont claires, les vendeurs sérieux et la prise de contact très simple. Je recommande vivement !",
    name: "Karim Benhaddou",
    role: "Acheteur — Casablanca",
    stars: 5,
  },
  {
    text: "Vendre ma voiture n'a jamais été aussi facile. J'ai publié mon annonce en quelques minutes et j'ai reçu des messages le jour même. Expérience parfaite.",
    name: "Salma Alaoui",
    role: "Vendeure — Rabat",
    stars: 5,
  },
  {
    text: "Plateforme très intuitive. J'ai comparé plusieurs offres, les filtres de recherche sont précis et j'ai pu trouver exactement ce que je cherchais.",
    name: "Youssef El Fassi",
    role: "Acheteur — Marrakech",
    stars: 5,
  },
];

export const Reviews = () => {
  const { t } = useTranslation();
  const [reviews, setReviews] = useState(REVIEWS);

  useEffect(() => {
    axios.get(`${BASE}/api/account/public-profiles`)
      .then(r => {
        const sellers = (Array.isArray(r.data) ? r.data : [])
          .filter(s => s.fullName);

        if (sellers.length === 0) return;

        setReviews(REVIEWS.map((review, i) => {
          const seller = sellers[i % sellers.length];
          if (!seller) return review;

          // Vraie photo si le vendeur en a une ; sinon un avatar généré à
          // partir de son vrai nom (jamais une des photos d'illustration).
          const realImage = seller.profileImage
            ? `${BASE}/profile-images/${seller.profileImage}`
            : `https://ui-avatars.com/api/?name=${encodeURIComponent(seller.fullName)}&background=5F41E4&color=fff&size=200&bold=true`;

          const roleLabel = seller.role === 'Professionnel'
            ? t('sellerTypes.Professionnel')
            : t('sellerTypes.Particulier');

          return {
            ...review,
            name: seller.fullName,
            role: seller.address ? `${roleLabel} — ${seller.address}` : roleLabel,
            image: realImage,
            fallbackImage: realImage,
          };
        }));
      })
      .catch(() => {});
  }, [t]);

  return (
    <section className="rvw">
      <div className="rvw__inner">

        {/* Header */}
        <div className="rvw__head">
          <span className="rvw__label">{t('testimonialsLabel')}</span>
          <h2 className="rvw__title">{t('testimonialsTitle')}</h2>
          <p className="rvw__sub">{t('testimonialsSub')}</p>
        </div>

        {/* Launch message */}
        <div className="rvw__launch">
          <RocketLaunchOutlinedIcon className="rvw__launch-icon" sx={{ fontSize: 24, color: "#a78bfa" }} />
          <span>{t("heroLaunchMessage")}</span>
        </div>

        {/* Cards */}
        <div className="rvw__grid">
          {reviews.map((r, i) => (
            <div key={i} className="rvw__card">
              <FormatQuoteIcon className="rvw__quote-icon" sx={{ fontSize: 36, color: '#5F41E4', opacity: 0.25 }} />
              <p className="rvw__text">{r.text}</p>
              <div className="rvw__stars">
                {Array.from({ length: r.stars }).map((_, s) => (
                  <StarIcon key={s} sx={{ fontSize: 18, color: '#f59e0b' }} />
                ))}
              </div>
              <div className="rvw__author">
                <img
                  src={r.image}
                  alt={r.name}
                  className="rvw__avatar"
                  onError={e => {
                    if (r.fallbackImage) e.target.src = r.fallbackImage;
                  }}
                />
                <div>
                  <div className="rvw__author-name">{r.name}</div>
                  <div className="rvw__author-role">{r.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
